<template>
  <div class="template-default">
    <nav class="navbar navbar-expand-lg navbar-dark py-3 px-0">
      <div class="container-fluid px-4 px-lg-5">
        <router-link class="navbar-brand mr-5" :to="{ name: 'home' }">
          <img src="../assets/logo.png" height="32" />
        </router-link>
        <ChatIA v-if="$user.user && $user.user.id == 143951" />

        <div
          class="d-none d-lg-flex justify-content-between align-items-center flex-fill"
        >
          <main-menu v-if="!isShortCourse" />

          <div class="my-lg-0 ml-auto d-flex align-items-center">
            <search-form v-if="!isShortCourse" />
            <button
              v-else
              class="btn btn-primary btn-gw rounded-pill"
              @click="clickGw"
            >
              ACESSAR GW COMPLETO (7 DIAS)
            </button>

            <action-dispatcher
              action="user/get"
              small
              @success="successUser"
              @error="logout"
            >
              <account-menu @logout="logoutDialog = true" />
            </action-dispatcher>
          </div>
        </div>

        <button class="btn-menu d-lg-none" @click="showingMobileMenu = true">
          <i class="fas fa-bars text-light"></i>
        </button>
      </div>
    </nav>

    <drawer :visible.sync="showingMobileMenu">
      <main-menu @logout="logoutDialog = true" />
    </drawer>

    <action-dispatcher
      action="courses/getCategories"
      class="flex-fill"
      loading-class="my-5"
    >
      <action-dispatcher action="courses/getFeed" loading-class="my-5">
        <slot />
      </action-dispatcher>
    </action-dispatcher>

    <app-footer />

    <confirmation
      v-model="logoutDialog"
      @confirm="logout"
      text="Tem certeza que deseja sair?"
      confirm-button-text="Sair"
    />

    <!-- <b-modal v-model="quizDialog" hide-footer hide-header>
      <quiz-questions :questions="questions" @success="quizDialog = false" />
    </b-modal> -->
  </div>
</template>

<script>
import AccountMenu from "@/components/template/AccountMenu";
import AppFooter from "@/components/template/AppFooter";
// import QuizQuestions from "@/components/template/QuizQuestions";
import SearchForm from "@/components/template/SearchForm";
import MainMenu from "@/components/template/MainMenu";
import ChatIA from "@/components/ChatIA";
import { Drawer } from "element-ui";
import { mapState } from "vuex";

export default {
  components: {
    AccountMenu,
    AppFooter,
    // QuizQuestions,
    SearchForm,
    MainMenu,
    Drawer,
    ChatIA
  },
  data() {
    return {
      showingMobileMenu: false,
      logoutDialog: false,
      quizDialog: false
    };
  },
  computed: {
    ...mapState("quiz", ["questions", "answers"]),
    isShortCourse() {
      return this.$route.name === "short-course";
    }
  },
  watch: {
    "$route.fullPath"() {
      this.showingMobileMenu = false;
    }
  },
  mounted() {
    this.$store.dispatch("courses/getMicrolearnings");

    this.$store.dispatch("quiz/getAnswers").then(() => {
      if (this.answers.length === 0) {
        this.$store.dispatch("quiz/getQuestions").then(() => {
          this.quizDialog = true;
        });
      }
    });
  },
  methods: {
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push({ name: "login" });
      });
    },
    successUser() {
      this.$store.commit("user/setLogged", true);
    },
    clickGw() {
      this.$router.push({ name: "home" });
    }
  }
};
</script>

<style lang="scss" scoped>
.template-default {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;

  .navbar {
    background: #131212;
    border-bottom: 3px solid black;

    .nav-link {
      font-weight: 500;
    }

    .btn-menu {
      background: transparent;
      border: none;
      padding: 0;
      font-size: 24px;
    }

    .btn-gw {
      font-size: 14px;
      font-weight: 500;
      padding: 11px 32px;
    }
  }
}
</style>
